import {routes, request} from "./"

export function markRequestsAsPrinted(commit, requestsArray) {
    return request(commit, routes.catalog.print, requestsArray, 'post')
}


//////////////////
// WEBPACK FOOTER
// ./vue/src/store/api/catalog.js
// module id = 603
// module chunks = 0